import React from 'react';
import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import {SectionPaddingHalfTop, SectionPaddingHalfBottom} from '@/section';
import {H1} from '@/typography';
import {BreakVisibleInDesktop} from '@/breaks';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import {withGreen800} from '@/hocs/withColors';
import PictureWrapper from '@/ui/images-wrapper';
import {useTranslations} from 'next-intl';

const LeftCentered = withTextLeftToCenter('div');
const H1Green800 = withGreen800(H1);

const imgPath = '/static/images/about/';

const AboutTop = props => {
  const t = useTranslations('about.topSection');

  return (
    <SectionPaddingHalfBottom>
      <Container variant="section-padding-below-nav">
        <SectionPaddingHalfTop>
          <Grid fluid>
            <Row middle="xs" center="xs" start="lg">
              <Col xs={12} lg={6}>
                <LeftCentered>
                  <H1Green800>
                    {t.rich('title', {
                      br: () => <BreakVisibleInDesktop />
                    })}
                  </H1Green800>
                </LeftCentered>
              </Col>
              <Col xs={12} lg={5} lgOffset={1}>
                <PictureWrapper
                  imgPath={imgPath}
                  imageUrl="about-us-hero-visual"
                  imageTypeFallback="jpg"
                  alt={t('imageAlt')}
                  fetchpriority="high"
                  loading="eager"
                />
              </Col>
            </Row>
          </Grid>
        </SectionPaddingHalfTop>
      </Container>
    </SectionPaddingHalfBottom>
  );
};

export default AboutTop;
